import type { FC, PropsWithChildren } from "react";

import dompurify from "isomorphic-dompurify";

import "./FlavorFinderHeader.scss";

export type FlavorFinderHeaderProps = {
  title?: string;
  subtitle?: string;
  infoText?: string;
};

const { sanitize } = dompurify;

export const FlavorFinderHeader: FC<PropsWithChildren<FlavorFinderHeaderProps>> = ({
  title,
  subtitle,
  children,
  infoText,
}) => {
  return (
    <div className="flavorfinder__header">
      {infoText && (
        <div dangerouslySetInnerHTML={{ __html: sanitize(infoText) }} className="flavorfinder__header-info"></div>
      )}
      {title && <h1 dangerouslySetInnerHTML={{ __html: sanitize(title) }} className="flavorfinder__header-title"></h1>}
      {subtitle && (
        <p dangerouslySetInnerHTML={{ __html: sanitize(subtitle) }} className="flavorfinder__header-subtitle"></p>
      )}
      {children}
    </div>
  );
};
